export enum StatusEventType {
  FAILURE = 'F',
  WARNING = 'W',
  INFO = 'I',
  DEBUG = 'D',
  INHIBIT = 'IH',

  UNSUPPORTED = 'U',
  UNDEFINED = ''
}